var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 126C97.7939 126 126 97.7939 126 63C126 28.2061 97.7939 0 63 0C28.2061 0 0 28.2061 0 63C0 97.7939 28.2061 126 63 126Z",
    fill: "#F94343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9776 9.2373C102.259 19.0291 105.862 30.6684 105.862 43.1391C105.862 77.9646 77.6873 106.139 42.8618 106.139C30.7606 106.139 19.4908 102.721 9.88379 96.8092C21.0612 114.268 40.6448 125.907 62.9996 125.907C97.8251 125.907 126 97.7329 126 62.9074C126 40.1831 113.991 20.3223 95.9776 9.2373Z",
    fill: "#E53939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59067 69.6509C8.59067 37.3195 34.8253 11.1773 67.0643 11.1773C85.9088 11.1773 102.721 20.1377 113.437 33.994C103.368 16.4427 84.4308 4.61865 62.7226 4.61865C30.3913 4.61865 4.24902 30.8533 4.24902 63.1846C4.24902 76.5791 8.77542 88.9574 16.3502 98.8415C11.3619 90.2506 8.59067 80.2741 8.59067 69.6509Z",
    fill: "#F76363"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.042 55.7026C100.042 55.6102 100.042 55.6102 100.042 55.5178C100.042 44.4328 92.0056 34.2715 79.9968 34.2715C70.3898 34.2715 64.8472 41.1073 62.9997 47.5735C61.0598 41.1073 55.5173 34.2715 46.0027 34.2715C33.9939 34.2715 25.9572 44.4328 25.9572 55.5178C25.9572 55.6102 25.9572 55.6102 25.9572 55.7026C25.8648 58.1043 25.9572 82.6762 62.9997 102.629C100.042 82.5838 100.135 58.1043 100.042 55.7026Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.1698b6c30e914dd00267f5a58335ee3f.svg";
export { ForwardRef as ReactComponent };